import {Label, Scenario, StaticMethods} from './GeneralModels';
import {AppSettingsService} from '../services/app-settings.service';

interface SubsetInterface {
  currentStep: string;
  displayArray: any;
  mainLabel: string;
  secondaryLabel: string;
  id: number;
  formID: number;
  firstName: string;
  lastName: string;
  relation: string;
  FormsSubmission: boolean;
  checkStepStatus: (step: string, object: SubsetInterface) => boolean;
}

export class SubsetDetails implements SubsetInterface {
  currentStep: string;
  displayArray: any = {};
  mainLabel = '';
  secondaryLabel = '';

  id: number;

  formID: number;

  firstName: string;

  lastName: string;

  relation: string;

  FormsSubmission: boolean;

  DoctorOrder: boolean;

  letterReleased: boolean;

  letterType?: string;

  testStatus?: Label;

  employeeReply?: string;

  employeeReplyStatus?: string;

  productName: string;

  Bill: boolean;

  damageType: string;

  damageAmount: string;

  documentsSendMethod: string;

  acceptedAmount: string;
  dateOfPayment: string;

  constructor({
                id, firstName, lastName,
                relation, FormsSubmission,
                DoctorOrder, formID, Bill, damageType, damageAmount, dateOfPayment,
                letterReleased, letterType, testStatus, acceptedAmount,
                employeeReply, employeeReplyStatus, documentsSendMethod
              },
              productName,
              scenario: Scenario) {
    this.productName = productName;
    this.employeeReplyStatus = employeeReplyStatus;
    this.employeeReply = employeeReply;
    this.testStatus = testStatus ? new Label(testStatus.englishLabel, testStatus.persianLabel) : null;
    this.formID = formID;
    this.Bill = Bill;
    this.damageAmount = damageAmount ? StaticMethods.numberWithCommas(damageAmount) : null;
    this.damageType = damageType;
    this.letterType = letterType;
    this.letterReleased = letterReleased;
    this.DoctorOrder = DoctorOrder;
    this.FormsSubmission = FormsSubmission;
    this.dateOfPayment = dateOfPayment;
    this.relation = relation;
    this.acceptedAmount = acceptedAmount ? StaticMethods.numberWithCommas(acceptedAmount) : null;
    this.lastName = lastName;
    this.firstName = firstName;
    this.documentsSendMethod = documentsSendMethod;
    this.id = id;
    if (!employeeReply) {
      this.employeeReply = 'NO_REPLY';
    }
    this.currentStep = StaticMethods.setStep(scenario, this.checkStepStatus, this);
    this.setDisplayArray();
  }

  getDisplayArray() {
    return this.displayArray;
  }

  setDisplayArray() {
    switch (this.productName) {
      case 'INTRODUCTION_LETTER':
        this.displayArray.DoctorOrder = this.DoctorOrder + '_FILE_STATUS';
        if (this.testStatus) {
          this.displayArray[this.testStatus.getPersianLabel()] = false + '_FILE_STATUS';
        }
        if (this.getFormsSubmission()) {
          this.displayArray.letterType = this.letterType;
        }
        break;
      case 'RECOMPENSE':
        this.displayArray.Bill = this.Bill + '_FILE_STATUS';
        if (this.getFormsSubmission()) {
          this.displayArray.damageType = this.damageType;
          this.displayArray.damageAmount = this.damageAmount;
          if (this.acceptedAmount) {
            this.displayArray.acceptedAmount = this.acceptedAmount;
          }
          if (this.dateOfPayment) {
            this.displayArray.dateOfPayment = this.dateOfPayment;
          }
        }
        break;
    }
    this.displayArray.FormsSubmission = this.FormsSubmission;
    if (this.employeeReply) {
      this.displayArray.employeeReply = this.employeeReply;
    }
    this.displayArray.status = this.getStep();
  }

  getId() {
    return this.id;
  }

  getFormID() {
    return this.formID;
  }

  getLetterType() {
    return this.letterType;
  }

  getRelation() {
    return this.relation;
  }

  getFormsSubmission() {
    return this.FormsSubmission;
  }

  getEmployeeReplyStatus() {
    return this.employeeReply;
  }

  getDoctorOrder() {
    return this.DoctorOrder;
  }

  getTestStatus() {
    return this.testStatus;
  }

  setMainLabel(label: string) {
    this.mainLabel = label;
  }

  setSecondaryLabel(label: string) {
    this.secondaryLabel = label;
  }

  getMaiLabel() {
    return this.mainLabel;
  }

  getSecondaryLabel() {
    return this.secondaryLabel;
  }

  getFirstName() {
    return this.firstName;
  }

  getLastName() {
    return this.lastName;
  }

  getStep(): string {
    return this.currentStep;
  }

  checkStepStatus = (step: string, object: SubsetDetails): boolean => {
    switch (object.productName) {
      case 'INTRODUCTION_LETTER':
        switch (step) {
          case IntroductionLetterScenario.fileUploaded:
            return object.DoctorOrder;
          case IntroductionLetterScenario.formSubmitted:
            return object.FormsSubmission;
          case IntroductionLetterScenario.employeeReplied:
            return !(!object.employeeReplyStatus) && object.employeeReplyStatus !== 'WAITING_FOR_EMPLOYEE';
          case IntroductionLetterScenario.testUploaded:
            return object.testRequired();
          case IntroductionLetterScenario.rejected:
            return object.employeeReply === 'REJECT';
          case IntroductionLetterScenario.waitingForRelease:
            return object.letterReleased;
          case IntroductionLetterScenario.letterReleased:
            return !object.letterReleased;
        }
        break;
      case 'RECOMPENSE':
        switch (step) {
          case RecompenseScenario.fileUploaded:
            return object.Bill;
          case RecompenseScenario.formSubmitted:
            return object.FormsSubmission;
          case RecompenseScenario.employeeReplied:
            return !(!object.employeeReplyStatus) && object.employeeReplyStatus !== 'WAITING_FOR_EMPLOYEE';
          case RecompenseScenario.testUploaded:
            return object.testRequired();
          case RecompenseScenario.rejected:
            return object.employeeReply === 'REJECT_FILE';
          case RecompenseScenario.sendingDocument:
            return object.employeeReply !== 'ACCEPT_FILE';
          case RecompenseScenario.documentTest:
            return object.employeeReply !== 'TEST_DOCUMENT';
          case RecompenseScenario.documentAccepted:
            return object.employeeReply !== 'ACCEPT_DOCUMENT';
          case RecompenseScenario.documentRejected:
            return object.employeeReply !== 'REJECT_DOCUMENT';
        }
        break;
      default:
        throw new Error('product not supported: ' + object.productName);
    }
  }

  private testRequired(): boolean {
    if (this.employeeReplyStatus === 'WAITING_FOR_USER' && this.testStatus) {
      return !this.testStatus.getEnglishLabel();
    } else {
      return true;
    }
  }

  getFileType(translationsService: AppSettingsService): Label {
    let scenario;
    switch (this.productName) {
      case 'INTRODUCTION_LETTER':
        scenario = IntroductionLetterScenario;
        break;
      case 'RECOMPENSE':
        scenario = RecompenseScenario;
        break;
      default:
        throw new Error('product not supported: ' + this.productName);
    }
    if (this.currentStep === scenario.fileUploaded) {
      return !this.DoctorOrder ? new Label(scenario.fileType,
        translationsService.translateEnglish(scenario.fileType)) : null;
    }
    if (this.currentStep === scenario.testUploaded) {
      return this.testStatus;
    }
  }
}

export class Insurance {
  public subsetList: SubsetDetails[];
  public insuranceNumber: string;
  public id: number;
  public productName: string;
  public companyName: string;
  public offerID: number;
  public multipleSubRequests: boolean;
  public locked: boolean;

  constructor(productName?: string, data?: {
    id,
    subsetList, productName, offerID, companyName, insuranceNumber, multipleSubRequests, locked
  }) {
    if (data) {
      this.id = data.id;
      this.offerID = data.offerID;
      this.subsetList = [];
      this.locked = data.locked;
      let scenario: { getMultipleScenario };
      switch (productName) {
        case 'INTRODUCTION_LETTER':
          scenario = IntroductionLetterScenario;
          break;
        case 'RECOMPENSE':
          scenario = RecompenseScenario;
          break;
        default:
          throw new Error('product not supported: ' + productName);
      }
      data.subsetList.forEach(subset => {
        this.subsetList.push(new SubsetDetails(subset, productName, scenario.getMultipleScenario()));
      });
      this.productName = data.productName;
      this.companyName = data.companyName;
      this.insuranceNumber = data.insuranceNumber;
      this.multipleSubRequests = data.multipleSubRequests;
    } else {
      this.subsetList = [];
      this.id = null;
      this.productName = '';
    }
  }
}

export class IntroductionLetterScenario {
  static readonly fileUploaded = 'fileUploaded';
  static readonly fileType = 'DoctorOrder';
  static readonly formSubmitted = 'formSubmitted';
  static readonly employeeReplied = 'employeeReplied';
  static readonly testUploaded = 'testUploaded';
  static readonly waitingForRelease = 'waitingForRelease';
  static readonly letterReleased = 'letterReleased';
  static readonly rejected = 'rejected';
  static scenarios = {
    GENERAL: new Scenario([
      IntroductionLetterScenario.formSubmitted,
      IntroductionLetterScenario.fileUploaded,
      IntroductionLetterScenario.employeeReplied,
      IntroductionLetterScenario.testUploaded,
      IntroductionLetterScenario.rejected,
      IntroductionLetterScenario.waitingForRelease,
      IntroductionLetterScenario.letterReleased
    ]),
  };

  static getMultipleScenario(): Scenario {
    return this.scenarios.GENERAL;
  }
}

export class RecompenseScenario {
  static readonly fileUploaded = 'fileUploaded';
  static readonly fileType = 'Bill';
  static readonly formSubmitted = 'formSubmitted';
  static readonly employeeReplied = 'employeeReplied';
  static readonly testUploaded = 'testUploaded';
  static readonly rejected = 'rejected';
  static readonly sendingDocument = 'sendingDocument';
  static readonly documentTest = 'documentTest';
  static readonly documentAccepted = 'documentAccepted';
  static readonly documentRejected = 'documentRejected';
  static scenarios = {
    GENERAL: new Scenario([
      RecompenseScenario.formSubmitted,
      RecompenseScenario.fileUploaded,
      RecompenseScenario.employeeReplied,
      RecompenseScenario.testUploaded,
      RecompenseScenario.sendingDocument,
      RecompenseScenario.documentTest,
      RecompenseScenario.documentAccepted,
      RecompenseScenario.documentRejected,
      RecompenseScenario.rejected,
    ]),
  };

  static getMultipleScenario(): Scenario {
    return this.scenarios.GENERAL;
  }
}

export class Subset {
  constructor(public firstName: string,
              public lastName: string,
              public relation: string,
              public locked?: boolean,
              public subRequestID?: number) {
    if (!locked) {
      this.locked = false;
    }
    if (subRequestID) {
      this.locked = true;
    }
  }
}

export class InsuranceMinimalInfo {
  public subsetList: Subset[];
  public insuranceNumber: string;
  public id: number;
  public productName: string;
  public companyName: string;
  public multipleSubRequests: boolean;
  public offerID: number;

  constructor(data?: any) {
    if (data) {
      this.id = data.id;
      this.offerID = data.offerID;
      this.subsetList = [];
      data.subsetList.forEach(subset => {
        this.subsetList.push(new Subset(subset.firstName, subset.lastName, subset.relation, true));
      });
      this.productName = data.productName;
      this.companyName = data.companyName;
      this.insuranceNumber = data.insuranceNumber;
      this.multipleSubRequests = data.multipleSubRequests;
    } else {
      this.subsetList = [];
      this.id = null;
      this.productName = '';
    }
  }
}
